import * as React from 'react';
import ReportProblemButton from 'app/components/ReportProblem/ReportProblemButton';
import SVG from 'react-inlinesvg';
import NotificationStatusBar from './FooterComponent/NotificationStatusBar';

const goToFacebook = () => {
  window.open('https://www.facebook.com/uniracinc/', '_blank');
};

const goToTwitter = () => {
  window.open('https://twitter.com/Unirac', '_blank');
};

const goToLinkedin = () => {
  window.open('https://www.linkedin.com/company/unirac-inc-/', '_blank');
};

const goToYoutube = () => {
  window.open('https://www.youtube.com/user/uniracsolar1/', '_blank');
};

const goToUniracSite = () => {
  window.open('http://www.unirac.com', '_blank');
};

const Footer = ({ ContainerFooter, props, RightSideFooter }: { ContainerFooter?: React.ComponentType, props?: any, RightSideFooter?: any }) => (
  <footer className="app__footer">
    <NotificationStatusBar />
    <div className="footer_button">
      {ContainerFooter && <ContainerFooter {...props}/>}
    </div>
    <ReportProblemButton />
    <div className="contact-field">
      {RightSideFooter && RightSideFooter()}
      <button type="button" className="share" onClick={goToUniracSite} aria-label="Open Unirac website">
        <img className="unirac-black" src={require('assets/media/logos/Unirac_blue.png')} alt="Unirac" />
      </button>
      <div className="social-media-icons" aria-label="Unirac social media links">
        <button type="button" onClick={goToFacebook} aria-label="Open Unirac Facebook"><SVG src={require('assets/media/icons/facebook_icon.svg')} /></button>
        <button type="button" onClick={goToYoutube} aria-label="Open Unirac YouTube"><SVG src={require('assets/media/icons/youtube_icon.svg')} /></button>
        <button type="button" onClick={goToTwitter} aria-label="Open Unirac Twitter"><SVG src={require('assets/media/icons/twitter_icon.svg')} /></button>
        <button type="button" onClick={goToLinkedin} aria-label="Open Unirac LinkedIn"><SVG src={require('assets/media/icons/linkedin_icon.svg')} /></button>
      </div>
    </div>
  </footer>
);

export default Footer;
